import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';



import { GetApi } from '../../../js_assets/Network';
import { getParameterByName } from '../../../js_assets/getParameterByName'

import { Grid } from '@material-ui/core';


import AppAdminContainer from '../AppAdminContainer'

import AgGridTable from '../../agGridTable'





const styles = theme => ({
    root: {
        flexGrow: 1,
        marginTop: 8,
        margin: 12

    },
    divider: {
        width: '100%',
    },
    btn_login: {
        color: 'white',
        padding: '10px 1px',
        border: 'none',
        cursor: 'pointer',
        width: '30%',
        opacity: '0.9',
        borderRadius: '3px',
        backgroundColor: '#b1d236',
        fontSize: 18
    },
    ButtonLocation: {
        backgroundColor: '#4CAF50',
        color: 'white',
        '&:hover': {
            background: '#4CAF50'
        }
    },
    ButtonGuide: {
        backgroundColor: '#74cbc4',
        color: 'white',
        '&:hover': {
            background: '#74cbc4'
        },
        margin: theme.spacing.unit,
        padding: '2px'
    },
    tab: {
        flexGrow: 1,
        marginTop: 2,
        backgroundColor: '#f7faea'

    },
    iocns: {
        fontSize: 18
    }


});

class AdminSubscriptionCourse extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Subscription_Course_data: [],
            trainer_schedule: [],
            loading_Schedule_Table: true,
            loading_state_iocn: true,
            loading_state_iocn2: true,
            columnDefs: [],
            rowData: [],
            Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
        };
    }

    componentDidMount() {


        const { Admin_Info } = this.state;

        let course_Id = getParameterByName("course_Id")


        if (course_Id !== null) {




            //console.log("TrainerID" + TrainerID)


            Promise.all([
                GetApi(`/api/course/Get_Subscription_Course/${course_Id}`, Admin_Info.jwT_Token_Admin),



            ]).then(rep => {


                this.ini_filter_date_point(rep[0])

                this.init_columnDefs();


            })







        }


    }


    ini_filter_date_point = (point_Report) => {

        let new_data_arr = [];


        if (point_Report.length !== 0) {
            point_Report.map(rep => {

                rep.subscription_Course_DateTime = rep.subscription_Course_DateTime.split("T")[0];

                new_data_arr.push(rep);

            })

        }


        this.setState({ Subscription_Course_data: new_data_arr, loading_state_iocn2: false })

    }






    init_columnDefs = () => {


        const { Subscription_Course_data } = this.state




        let columnDefs = [
            { headerName: "اسم الدورة", field: "course_Name" },
            { headerName: " الاسم ", field: "userName" },
            { headerName: "رقم الجوال", field: "user_Phone" },
            { headerName: " الايميل", field: "user_Email" },
            { headerName: "تاريخ الاشراك", field: "subscription_Course_DateTime" },
            { headerName: "رقم ميسر", field: "payment_Transaction_Id" },


        ]




        this.setState({ columnDefs: columnDefs, rowData: Subscription_Course_data, loading_Schedule_Table: false })


    }








    render() {
        const { classes } = this.props;
        const { columnDefs, rowData, loading_Schedule_Table } = this.state;


        //console.log()
        return (

            <AppAdminContainer Title={"الدوره"} >


                <div>


                    <Grid justify="center" alignItems="center" container spacing={8}>
                        <h3 className="containerOfferh4" >  الاشتراكات  </h3>
                        <br></br>
                    </Grid>
                    <br></br>


                    <br></br>
                    <Grid justify="center" alignItems="center" container spacing={8}  >
                        <AgGridTable loading_state_Table={loading_Schedule_Table} columnDefs={columnDefs} rowData={rowData} />
                    </Grid>



                </div>





            </AppAdminContainer >




        )
    }


}
AdminSubscriptionCourse.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminSubscriptionCourse);